<template>
	<div
		:class="['panel', 'discourse-schedule',
			isHeaderIndent? 'mt-0 pt-1' : '',
			isFooterIndent? 'mb-0 pb-1' : '',
			block.appearance? block.appearance : ''
		]"
		:style="block.background_image ?
			'background-image:url(' + block.background_image.src + ')' : ''"
	>
		<div class="container">
			<div class="row">
				<!-- <div class="col-12 col-lg-6 order-lg-1"> -->
				<div class="col-12 col-lg-6">
					<div class="overview_block">
						<div v-if="block.block_title" class="title title-lg">
							{{ block.block_title }}
						</div>
						<div v-if="block.description" class="description" v-html="block.description" />
						<dynamic-button
							:button="block.button"
							:block-id="block.id"
							:scenario="block.scenario"
						/>
					</div>
				</div>

				<div class="col-12 col-lg-6">
					<div class="schedule_block">
						<h2 v-if="block.second_title" class="title title-lg">
							{{ block.second_title }}
						</h2>
						<ul class="schedule_list">
							<li v-for="(item, index) in block.items" :key="index">
								<!-- <div class="description">Сессия 1</div> -->
								<div class="title">
									{{ item.title }}
								</div>
								<div class="description" v-html="item.description" />
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import panel from '~/mixins/panel';

export default {
	name: 'DiscourseTalk',
	mixins: [panel],
};
</script>
<style lang="scss" scoped>
	@import "~/assets/styles/components/home/panel-discourse-talk-bg";
</style>
